import React from "react";

const Testimonials = () => {
  const steps = [
    {
      number: "1",
      icon: "fas fa-paper-plane",
      title: "Kontakt",
      desc: "Napisz przez formularz, e-mail lub media społecznościowe. Opowiedz, czego potrzebujesz i jaki efekt chcesz osiągnąć.",
    },
    {
      number: "2",
      icon: "fas fa-comments",
      title: "Rozmowa i plan",
      desc: "Poznaję Twoje potrzeby, proponuję najlepsze rozwiązanie, ustalamy zakres współpracy, termin realizacji oraz wycenę.",
    },
    {
      number: "3",
      icon: "fas fa-video",
      title: "Realizacja nagrań",
      desc: ["Spotykamy się w ustalonym terminie, a ja zajmuję się realizacją materiału."," Ty możesz skupić się na swojej pracy, a ja dbam o każdy detal nagrań."],
    },
    {
      number: "4",
      icon: "fas fa-film",
      title: "Montaż",
      desc: "Tworzę dynamiczny film, który przyciąga uwagę i przedstawia Twoją firmę w najlepszym świetle. Dbam o montaż, kolory, dźwięk i wszystkie detale wpływające na końcowy efekt.",
    },
    {
      number: "5",
      icon: "fas fa-check-circle",
      title: "Gotowy materiał",
      desc: "Po akceptacji otrzymujesz gotowy film przygotowany do publikacji w social media lub na stronie internetowej.",
    },
        {
      number: "6",
      icon: "fas fa-chart-bar",
      title: "Efekty",
      desc: "Film zaczyna pracować na Twoją markę. Obserwujesz większe zainteresowanie ofertą, więcej zapytań od klientów i uzyskujesz profesjonalny wizerunek, który buduje zaufanie.",
    },
  ];

  return (
    <section id="testimonial" className="section bg-light">
      <div className="container">

        {/* Heading */}
        <p className="text-center mb-2 wow fadeIn">
          <span className="bg-primary text-dark px-2">
            Współpraca
          </span>
        </p>

        <h2 className="text-10 fw-600 text-black text-center mb-3 wow fadeIn">
          Jak wygląda pierwsza współpraca?
        </h2>

        <p className="text-4 text-muted text-center mb-5 wow fadeIn">
          Od pierwszej wiadomości aż po gotowy film - cały proces jest prosty,
          przejrzysty i dopasowany do Twoich potrzeb.
        </p>

        <div className="row g-4">

          {steps.map((step, index) => (
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay={`${index * 0.15}s`}
              key={index}
            >
        <div className="process-card h-100">

    <div className="process-number">
        {step.number}
    </div>

    <div className="process-line"></div>

    <div className="process-icon">
        <i className={step.icon}></i>
    </div>

    <h4 className="process-title">
        {step.title}
    </h4>

    <p className="process-desc">
        {step.desc}
    </p>

</div>
            </div>
          ))}

        </div>

        <div className="text-center mt-5 wow fadeIn">
          <p className="text-muted mb-0">
            Każdy projekt jest inny, dlatego cały proces dopasowuję do Twoich
            potrzeb i charakteru Twojej marki.
          </p>
        </div>

      </div>
    </section>
  );
};

export default Testimonials;